export const generateOtp = () => {
  return Math.floor(100000 + Math.random() * 900000).toString();
};

export const isOtpValid = (generatedAt, validityMinutes = 5) => {
  const now = Date.now();
  const diff = now - generatedAt;
  return diff < validityMinutes * 60 * 1000;
};

export const sendOtpEmail = async (email, otp) => {
  const jsonPayload = {
    email,
    subject: "Assetrack - Your OTP Code",
    textbody: `Your OTP for Assetrack login is ${otp}. This code will expire in 5 minutes.`,
    htmlbody: `
      <div style="font-family: Arial, sans-serif; color: #333; max-width: 600px; margin: 0 auto;">
        <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 30px; text-align: center;">
          <h1 style="color: white; margin: 0; font-size: 32px;">Assetrack</h1>
          <p style="color: rgba(255,255,255,0.9); margin: 10px 0 0 0;">Asset Management System</p>
        </div>
        
        <div style="padding: 40px 30px; background: #f8f9fa;">
          <h2 style="color: #333; margin-bottom: 20px;">Email Verification</h2>
          <p style="font-size: 16px; line-height: 1.6; margin-bottom: 30px;">
            You requested to sign in to your Assetrack account. Use the verification code below to complete the process.
          </p>
          
          <div style="background: white; border: 2px dashed #667eea; border-radius: 12px; padding: 30px; text-align: center; margin: 30px 0;">
            <p style="margin: 0 0 10px 0; color: #666; font-size: 14px;">YOUR VERIFICATION CODE</p>
            <div style="font-size: 36px; font-weight: bold; color: #333; letter-spacing: 8px; font-family: monospace;">
              ${otp}
            </div>
          </div>
          
          <div style="background: #fff3cd; border-left: 4px solid #ffc107; padding: 15px; margin: 20px 0;">
            <p style="margin: 0; color: #856404;">
              <strong>Important:</strong> This code will expire in <strong>5 minutes</strong>. For your security, do not share this code with anyone.
            </p>
          </div>
          
          <p style="font-size: 14px; color: #666; margin-top: 30px;">
            If you didn't request this code, you can safely ignore this email.
          </p>
        </div>
        
        <div style="background: #333; color: white; padding: 20px; text-align: center;">
          <p style="margin: 0; font-size: 14px;">
            © 2024 Assetrack. All rights reserved.
          </p>
          <p style="margin: 5px 0 0 0; font-size: 12px; opacity: 0.8;">
            This is an automated message, please do not reply.
          </p>
        </div>
      </div>
    `,
    apiKey: "qwertyuiop",
  };

  const formData = new FormData();
  formData.append("jsonPayload", JSON.stringify(jsonPayload));

  try {
    const response = await fetch("https://email-a306.onrender.com/send-email", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to send OTP: ${errorText}`);
    }

    return { success: true };
  } catch (error) {
    console.error("Error sending OTP:", error.message);
    return { success: false, error: error.message };
  }
};
